import { render } from "./FeedbackPopover.vue?vue&type=template&id=43787b87&scoped=true"
import script from "./FeedbackPopover.vue?vue&type=script&lang=js"
export * from "./FeedbackPopover.vue?vue&type=script&lang=js"

import "./FeedbackPopover.vue?vue&type=style&index=0&id=43787b87&lang=scss&scoped=true"
import "./FeedbackPopover.vue?vue&type=style&index=1&id=43787b87&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43787b87"]])

export default __exports__